module.exports = __webpack_public_path__ + "static/media/48.24b3fc5c.png";